/** Tags domain storage. Cross-tab (localStorage) saved page length per tags tab, stored as a string. */
import Storage from '../index';
import StorageKeys from '../keys';

const tags = {
    getPageLength: (tab) => Storage.getRaw(StorageKeys.tagsPageLength(tab)),
    setPageLength: (tab, length) => Storage.setRaw(StorageKeys.tagsPageLength(tab), String(length)),
};

export default tags;
